import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";

import { LoginComponent } from "./login/login.component";
import { RegisterComponent } from "./register/register.component";
import { PopupLoginComponent } from "./popup-login/popup-login.component";
import { PopupLoginOptionsComponent } from "./popup-login-options/popup-login-options.component";

const routes: Routes = [
  { path: "login", component: LoginComponent },
  { path: "Registertion", component: RegisterComponent },
  { path: "popup-login", component: PopupLoginComponent },
  { path: "popup-login-option", component: PopupLoginOptionsComponent },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class AuthRoutingModule {}
